import React, { useState, useEffect, useMemo, useRef, useCallback } from "react";
import axios from 'util/axios';
import { getURLParam } from "util";

const clickAction = (uniqueCode, celNm, type, action) => {
    let find;
    let child;

    if (celNm.toString().match(/remark/gi)) {
        find = document.querySelector(`*[data-uniquecode=${uniqueCode}][data-cellnm=${celNm}]`);
        child = find;
    } else if (type.match(/(HEADER|COMMON|FOOTER|DES)/)) {


        find = document.getElementsByClassName("view-area");

        for(let i of find){
            child = i.querySelector(`*[data-uniquecode=${uniqueCode}]`);
            if(child != null){
                break;
            }
        }
    } else {
        find = document.querySelector(`*[data-uniquecode=${uniqueCode}]`);
        child = find?.querySelector(`*[data-cellnm=${celNm}]`);
    }



/*    if (action) {
        window.history.replaceState(
            null,
            "",
            `/review?geneCode=${action.geneCode}&revision=${action.revision}&tempYn=${action.tempYn}`
        );
    }*/
    child?.click();
};

const UnconfirmedList = (props) => {
    const [List, SetList] = useState([]);
    const [Show, SetShow] = useState(false);

    const containerRef = useRef(null);

    const oneClick = useRef(1);

    const getData = useCallback(async () => {
        const data = props.data;
        if (!data) {
            return;
        }

        const response = await axios.post(process.env.REACT_APP_API + "/pcsReview/findCompleteList", {sheetCode:data.descCode , revision:data.revision});
        
        const resData = response.data.data;
        SetList(resData?.result || []);




    }, [props.data]);

    const HandleClickEvent = useCallback(
        (e) => {
            if (e.target.closest(".show-btn")) {
                SetShow(!Show);
            }
        },
        [Show]
    );

    useEffect(() => {
        getData();
        containerRef?.current?.addEventListener("click", HandleClickEvent);
        return () => {
            containerRef?.current?.removeEventListener("click", HandleClickEvent);
        };
    }, [HandleClickEvent, getData, props]);

    const mainRender = useMemo(() => {
        let render;
        if (List.length > 0)
            render = [...List].map((rowData, index) => {
                return (
                    <tr
                        key={`unConfirmedList${index}`}
                        onClick={(e) => clickAction(rowData.uniqueCode, rowData.celNm, rowData.sheetType)}
                    >
                        {rowData.sheetType.match(/(HEADER|COMMON|FOOTER)/) ? (
                            <>
                                <td colSpan="2">{rowData.sheetType}</td>
                                <td title={rowData.paraNm}>{rowData.paraNm}</td>
                            </>
                        ) : (
                            <>
                                <td className={"text-center"}>{rowData.mbrNo}</td>
                                <td title={rowData.description}>{rowData.description}</td>
                                <td title={rowData.paraNm}>{rowData.paraNm}</td>
                            </>
                        )}
                    </tr>
                );
            });
        else
            render = (
                <tr>
                    <td colSpan="3">No List</td>
                </tr>
            );
        return render;
    }, [List]);

    return (
        <div className={`unconfirmlist-wrapper ${Show}`} ref={containerRef}>
            <div className={"show-btn"}>Unconfirmed</div>
            <div className={"content"}>
                <table className={"bpl-table-default small compact-row gray-tone fixed"} style={{ fontSize: "0.5rem" }}>
                    <colgroup>
                        <col width="35px" />
                        <col width="70px" />
                        <col />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>MBR</th>
                            <th>Desc</th>
                            <th>Para Nm.</th>
                        </tr>
                    </thead>
                    <tbody>{mainRender}</tbody>
                </table>
            </div>
        </div>
    );
};

export default UnconfirmedList;
